export default {
  setSocials: (state, payload) => {
    state.socials = payload;
  },
};
